module.exports = __webpack_public_path__ + "f3bf96ee150187cb8e197b4e2d0f758c.MP3";